export class AppSettings {
	private static _jsParams:any;
	private static _isBot:boolean;
	
	public static init():void {
		this._jsParams = window['params'];
		
		let rx = /bot|googlebot|crawler|spider|robot|crawling/i;
		AppSettings._isBot = (rx.test(window.navigator.userAgent) ||
			AppSettings.getJSParam("fakeBot") === true);
	}
	
	public static getJSParam(paramName:string):any {
		if (AppSettings._jsParams.hasOwnProperty(paramName)){
			return AppSettings._jsParams[paramName];
		}
		else {
			return null;
		}
	}
	
	public static get isBot():boolean {
		return AppSettings._isBot;
	}
	
	public static get resourcesPath():string {
		return AppSettings.getJSParam("resourcesUrl");
	}
	
	public static get pageUrl():string {
		return AppSettings.getJSParam("pageUrl");
	}
}